import { TOAST_TYPE_MAP, ToastCustom } from './ToastCustom';

/** Any known error-messages that we want to re-map in the interface. */
const ERROR_REMAP: Record<string, string> = {
    'Failed to fetch': 'Server is offline.',
    'Request Data Malformed': 'Invalid Action Requested. Please contact customer support'
};

/** Return a copy of obj without any entries where the value is falsy */
function removeFalsyValues(obj: any) {
    return Object.fromEntries(Object.entries(obj).filter(([value]) => !!value));
}

/**
 *  Handle an error response from the API. We always log whatever error context we find there but display the first of
 *  these that we find:
 *  - the `messageOverride` argument
 *  - the `data.message` field mapped by ERROR_REMAP
 *  - the `data.message` field
 *  - the `messageFallback` argument
 *  - the 'Unknown error' constant
 *
 *  We expect `response` to be either a reduxjs api response object or an axiosApi response, but the coding is defensive
 *  so in any case we should at least display the messageFallback.
 */
const ErrorHandler = (
    response: any,
    messageOverride: string | null = null,
    messageFallback: string | null = null
): any => {
    const data = response?.error?.data || response?.data || response?.response?.data;
    const headers = response?.headers || {};
    const errorMessage: string | undefined = data?.message || response?.message;
    const mappedMessage: string = ERROR_REMAP[errorMessage || ''] || errorMessage || messageFallback || 'Unknown error';
    const shownMessage = messageOverride || mappedMessage;
    const requestId = data?.details?.request_id || data?.details?.requestId || headers['x-request-id'];
    const status = response?.error?.status || data?.status;

    ToastCustom(shownMessage, TOAST_TYPE_MAP.ERROR, status === 500 && requestId);

    const toLog: any = {
        requestId,
        status,
        details: data?.details,
        errorMessage,
        messageOverride,
        messageFallback
    };
    console.info('API Error', removeFalsyValues(toLog));
};

export default ErrorHandler;
